__webpack_require__.p = "/back-office/menu-ui-component-react-v2/";